import React from 'react';

import MuiButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { BUTTON_SPINNER_SIZE } from 'helper/constant';
import PropTypes from 'prop-types';

import styles from './index.module.css';

const variants = cva(styles.base, {
    variants: {
        //extend as more intents are introduced
        intent: {
            primary: styles.primary,
            secondary: styles.secondary,
            'primary-outlined': styles['primary-outlined'],
            text: styles.text,
            danger: styles.danger,
        },
        size: {
            sm: styles.sm,
            md: styles.md,
            lg: styles.lg,
            xl: styles.xl,
            xxl: styles.xxl,
        },
    },
});

const Button = ({ className, intent, size, loading, disabled, endIcon, ...props }) => {
    return (
        <MuiButton
            className={clsx(className, variants({ intent, size }))}
            // `loading` implies disabled and swaps the end icon for a spinner.
            disabled={disabled || loading}
            endIcon={
                loading ? (
                    <CircularProgress
                        size={BUTTON_SPINNER_SIZE[size] ?? BUTTON_SPINNER_SIZE.md}
                        color="inherit"
                    />
                ) : (
                    endIcon
                )
            }
            {...props}
        />
    );
};

Button.defaultProps = {
    loading: false,
};

Button.propTypes = {
    className: PropTypes.string,
    //extend as more types are introduced
    intent: PropTypes.oneOf(['primary', 'secondary', 'primary-outlined', 'text', 'danger']),
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl']),
    // When true, shows a spinner as the end icon and disables the button.
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    endIcon: PropTypes.node,
};

export default Button;
